import { TTestingMethod } from './types';

export const REPORT_PAGE_LIMIT = 10;

export const DEFAULT_TESTING_METHOD: TTestingMethod = 'all';

export const VALID_TESTING_METHODS: TTestingMethod[] = ['all', 'sast', 'dast', 'sast-dast'];

export const REPORT_ROUTE_NAMES = {
  versionVulnerability: 'VersionVulnerability',
  singleScanVulnerability: 'SingleScanVulnerability',
  integrationBranch: 'Inner Integration',
  versionReport: 'VersionReport',
  singleScanReport: 'SingleScanReport',
} as const;

export const DEFAULT_FOLDER_NAMES = {
  mainReport: 'Main Report',
  allVulnerabilities: 'All Vulnerabilities',
  falsePositives: 'False Positives',
} as const;
